__webpack_require__.b = document.baseURI || self.location.href;

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	29753: 0,
	3201: 0,
	6315: 0,
	9389: 0,
	15424: 0,
	16902: 0,
	19667: 0,
	22225: 0,
	28773: 0,
	28970: 0,
	31146: 0,
	37415: 0,
	38074: 0,
	45338: 0,
	48727: 0,
	57293: 0,
	57431: 0,
	58281: 0,
	60229: 0,
	64492: 0,
	65404: 0,
	67240: 0,
	73369: 0,
	73560: 0,
	73575: 0,
	76413: 0,
	76512: 0,
	83846: 0,
	85243: 0,
	90920: 0,
	91472: 0,
	95721: 0,
	76949: 0,
	91422: 0,
	78046: 0,
	40311: 0,
	56847: 0,
	67493: 0,
	90759: 0,
	32223: 0,
	45784: 0
};

__webpack_require__.f.j = (chunkId, promises) => {
		// JSONP chunk loading for javascript
		var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
		if(installedChunkData !== 0) { // 0 means "already installed".

			// a Promise means "currently loading".
			if(installedChunkData) {
				promises.push(installedChunkData[2]);
			} else {
				if(!/^(1(4(81[34]|148)|6([79]02|50)|(022|279|296|542|826)4|3398|7|8951|9667)|2(8(97[04]|773)|090|1628|1859|2225|2633|3048|3264|4291|4756|5311|6660|9442|9753)|3(1146|201|2223|7415|7904|8074)|4(0311|048|4483|494|5338|5784|6846|6955|8221|8727)|5(7(293|415|431)|9(195|24|450)|(075|138|684)7|41|5378|5485|8281)|6(0229|1526|2482|315|4008|4492|5404|7240|7493)|7(3(369|560|575|990)|6(413|512|949)|(296|804|932)6|1085|1699|275|4650|5733|9222)|8(5(243|32|733)|3846|7861|971)|9(1(422|472|570)|0759|0920|3034|389|5294|5721|7355|7927|8373|9300|9996))$/.test(chunkId)) {
					// setup Promise in chunk cache
					var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
					promises.push(installedChunkData[2] = promise);

					// start chunk loading
					var url = __webpack_require__.p + __webpack_require__.u(chunkId);
					// create error before stack unwound to get useful stacktrace later
					var error = new Error();
					var loadingEnded = (event) => {
						if(__webpack_require__.o(installedChunks, chunkId)) {
							installedChunkData = installedChunks[chunkId];
							if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
							if(installedChunkData) {
								var errorType = event && (event.type === 'load' ? 'missing' : event.type);
								var realSrc = event && event.target && event.target.src;
								error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
								error.name = 'ChunkLoadError';
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							}
						}
					};
					__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
				} else installedChunks[chunkId] = 0;
			}
		}
};

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = globalThis["webpackChunk_github_ui_github_ui"] = globalThis["webpackChunk_github_ui_github_ui"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));